// Keep all the session and local storage related keys here.
const NAME = 'name';
const USERNAME = 'username';
const USER_ROLE = 'userRole';
const JWT_TOKEN = 'jwtToken';
const BRAND_NAME = 'brandName';
const AUTH_TOKEN = 'authToken';
const CURRENT_USER = 'currentUser';
const LAST_PATHNAME = 'lastPathname';
const ORGANIZATION_ID = 'organizationId';
const JWT_TOKEN_EXPIRY = 'jwtTokenExpiry';
const SANDBOX_VALIDITY = 'sandboxValidity';
const USER_BRAND_PIC_URL = 'userBrandPicUrl';
const SHOW_COLLAPSED_NAV = 'showCollapsedNav';
const ACTIVE_IMPERSONATOR = 'activeImpersonator';
const ORGANIZATION_USER_ID = 'organizationUserId';
const RAZORPAY_PROFILE_NAME = 'razorpayProfileName';
const MOBILE_UNSUPPORTED_ROUTES_EXCLUSION_LIST = 'mobileUnsupportedRoutesExclusionList';
const SSO_LOGOUT_URL = 'ssoLogoutUrl';
const AGENT_SIDEBAR_OPEN = 'agentSidebarOpen';
const AGENT_CURRENT_CONVERSATION_ID = 'agentCurrentConversationId';
const AGENT_SIDEBAR_WIDTH = 'agentSidebarWidth';
const JWT_DEV_TOKEN = 'jwtDevToken';
// Guest token for the v3 public page - its own key, it is not interchangeable with AUTH_TOKEN.
const GUEST_AUTH_TOKEN = 'guestAuthToken';

export {
  NAME,
  USERNAME,
  USER_ROLE,
  JWT_TOKEN,
  BRAND_NAME,
  AUTH_TOKEN,
  CURRENT_USER,
  LAST_PATHNAME,
  ORGANIZATION_ID,
  SANDBOX_VALIDITY,
  JWT_TOKEN_EXPIRY,
  USER_BRAND_PIC_URL,
  SHOW_COLLAPSED_NAV,
  ACTIVE_IMPERSONATOR,
  ORGANIZATION_USER_ID,
  RAZORPAY_PROFILE_NAME,
  MOBILE_UNSUPPORTED_ROUTES_EXCLUSION_LIST,
  SSO_LOGOUT_URL,
  AGENT_SIDEBAR_OPEN,
  AGENT_CURRENT_CONVERSATION_ID,
  AGENT_SIDEBAR_WIDTH,
  JWT_DEV_TOKEN,
  GUEST_AUTH_TOKEN,
};
